import { h } from 'preact'

const getComponentWithOptions = (baseClasses = '', opts, fn) => {
  const optionKeys = Object.keys(opts)

  return props => {
    let newProps
    let propsToMerge
    let final

    if (opts && fn) {
      const keys = Object.keys(props).concat(optionKeys)
      const extractedOpts = {}
      newProps = {}
      keys.forEach(key => {
        if (opts.hasOwnProperty(key)) {
          if (props.hasOwnProperty(key)) {
            extractedOpts[key] = props[key]
          } else {
            extractedOpts[key] = opts[key]
          }
        } else {
          newProps[key] = props[key]
        }
      })
      propsToMerge = fn(extractedOpts, props)
      final = Object.assign(newProps, propsToMerge)
    } else {
      final = props
    }

    return h(
      final.tagName || opts.tagName || 'div',
      Object.assign(final, {
        className: [baseClasses, final.className, props.className || '']
          .join(' ')
          .trim(),
        tagName: null
      })
    )
  }
}

const getComponent = (baseClasses, tagName = 'div') => props =>
  h(
    tagName,
    Object.assign({}, props, {
      className: `${baseClasses} ${props.className || ''}`
    })
  )

export default (baseClasses, options, fn) => {
  if (!options || typeof options === 'string') {
    return getComponent(baseClasses, options)
  }
  return getComponentWithOptions(baseClasses, options, fn)
}
